import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const fmtUsd = (n, digits = 0) =>
  n == null ? "—" : `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: digits })}`;

const fmtPrice = (p) => {
  if (p == null) return "—";
  const n = Number(p);
  return `$${n < 0.01 ? n.toFixed(6) : n.toFixed(4)}`;
};

/**
 * StatsBar accepts a `stats` prop from App.js (single-source polling).
 * If not provided (dev / isolated render), falls back to reading the last
 * cached values from window to avoid duplicate network calls.
 */
export const StatsBar = ({ stats: statsProp }) => {
  // Local state only used when no prop is passed (defensive fallback).
  const [stats, setStats] = useState(statsProp || null);
  useEffect(() => {
    if (statsProp) setStats(statsProp);
  }, [statsProp]);

  const up = stats && Number(stats.change24h) >= 0;
  const cells = [
    { label: "PRICE", value: fmtPrice(stats?.priceUsd), testId: "stat-price" },
    { label: "MARKET CAP", value: fmtUsd(stats?.marketCap), testId: "stat-mcap" },
    {
      label: "24H CHANGE",
      value: stats ? `${up ? "+" : ""}${Number(stats.change24h).toLocaleString()}%` : "—",
      testId: "stat-change",
      colored: true,
    },
    { label: "24H VOLUME", value: fmtUsd(stats?.volume24h), testId: "stat-volume" },
  ];

  return (
    <div
      data-testid="stats-bar"
      className="neon-card mt-14 grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#9945FF]/20 overflow-hidden"
    >
      {cells.map((c) => (
        <div key={c.label} className="px-5 py-4 sm:px-8 sm:py-5">
          <p className="font-bebas tracking-[0.25em] text-zinc-500 text-sm flex items-center gap-2">
            {c.label}
            {c.colored && stats && (up ? (
              <TrendingUp size={14} className="text-[#14F195]" />
            ) : (
              <TrendingDown size={14} className="text-red-400" />
            ))}
          </p>
          <p
            data-testid={c.testId}
            className={`font-bebas text-2xl sm:text-3xl mt-1 ${
              c.colored && stats ? (up ? "text-[#14F195]" : "text-red-400") : "text-white"
            }`}
          >
            {c.value}
          </p>
        </div>
      ))}
    </div>
  );
};
